
abstract class IModalService {
    public abstract addModal(key: string, overlayEl: Element, hidePreviousModal?: boolean) : void;
    public abstract removeModal(key: string) : void;
    public abstract generateModalKey(): string;
}

export { IModalService };
